import { FunctionComponent, useEffect } from 'react'
import { HeroBanner as HeroBannerProps } from './HeroBanner.types'
import { Image } from 'src/componentsV2/CoreUX/primitives/Image/Image'
import { Button } from 'src/componentsV2/CoreUX/primitives/Button/Button'
import { Text } from 'src/componentsV2/CoreUX/primitives/Text/Text'
import { useActions } from 'src/hooks/useActions'
import './HeroBanner.scss'

export const HeroBanner: FunctionComponent<HeroBannerProps> = ({
  attributes: { title, subtitle, image, button },
  actions
}) => {
  const { onView } = useActions(actions)

  useEffect(() => {
    onView()
  }, [onView])

  return (
    <div className="core-ux-hero-banner" data-testid="hero-banner">
      <div className="core-ux-hero-banner__content">
        <Text {...title} />
        <Text {...subtitle} />
        <Button {...button} />
      </div>
      <Image {...image} />
    </div>
  )
}
